import { render, staticRenderFns } from "./IssuesCard.vue?vue&type=template&id=7639b818"
import script from "./IssuesCard.vue?vue&type=script&lang=js"
export * from "./IssuesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports